export default __webpack_public_path__ + "static/media/bg2.6d3ac52a.png";